import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppErrorBoundary } from './Error/AppErrorBoundary';

const container = document.getElementById('surveyElement');
if (!container) {
  throw new Error('Root element #surveyElement was not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
